import { http } from '../services';

class ApresentacaoService {
    apresentacaoForm() {
        return http.get('/apresentacao/form');
    }

    async getApresentacaoSala(subevento, tipoApresentacao, sala, area) {
        return http.get('/apresentacao-sala', {
            subevento,
            tipoApresentacao,
            sala,
            area,
        });
    }

    save(apresentacao) {
        return http.post('/apresentacao', apresentacao);
    }

    delete(projeto, sala) {
        return http.delete('/apresentacao', {
            projeto,
            sala,
        });
    }
}

const apresentacaoService = new ApresentacaoService();
export default apresentacaoService;
